<main>
  <oaibox-stats-card
    title="New Deployment"
    icon="fa-duotone fa-solid fa-building-user"
    gradient="primary"
    [outlined]="true"
  >
    <form
      class="form p-g"
      [formGroup]="newDeploymentForm"
      (ngSubmit)="createDeployment()"
    >
      <div class="form-row flex-wrap align-items-start">
        <div class="flex-fill">
          <label for="name" class="form-label">Name</label>
          <input
            id="name"
            type="text"
            class="form-control"
            [formControl]="newDeploymentForm.controls.name"
          />
        </div>

        <div class="flex-fill">
          <label for="description" class="form-label">Description</label>
          <input
            id="description"
            type="text"
            class="form-control"
            [formControl]="newDeploymentForm.controls.description"
          />
        </div>

        <div class="flex-fill d-flex flex-column g-g">
          <div class="d-flex flex-column">
            <div
              class="d-inline-flex justify-content-between align-items-start g-g"
            >
              <label for="domain" class="form-label">Domain</label>
              <div class="form-switch domain-auto-assignment">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  [formControl]="
                    newDeploymentForm.controls.domainAutoAssignment
                  "
                />
                <label
                  >Let users with this email domain join automatically</label
                >
              </div>
            </div>
            <input
              id="domain"
              type="text"
              class="form-control"
              [formControl]="newDeploymentForm.controls.domain"
            />
          </div>
        </div>
      </div>

      <div class="license-configuration-wrapper">
        <div class="license-configuration">
          <div class="dropdown">
            <label for="licenseStatus" class="form-label">Status</label>
            <button
              id="licenseStatus"
              type="button"
              class="form-control dropdown-toggle"
              data-bs-toggle="dropdown"
            >
              {{
                newDeploymentForm.controls.licenseConfiguration.value.status ??
                  "Select status"
              }}
            </button>
            <ul class="dropdown-menu w-100">
              @for (licenseStatus of AVAILABLE_LICENSE_STATUS; track $index) {
                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    [class.selected]="
                      newDeploymentForm.controls.licenseConfiguration.value
                        .status === licenseStatus
                    "
                    (click)="onSelectLicenseStatus(licenseStatus)"
                  >
                    {{ licenseStatus }}
                  </button>
                </li>
              }
            </ul>
          </div>

          <div>
            <label for="startDate" class="form-label">Start Date</label>
            <input
              class="form-control"
              type="date"
              id="startDate"
              [formControl]="
                newDeploymentForm.controls.licenseConfiguration.controls
                  .startDate
              "
            />
          </div>
          <div>
            <label for="endDate" class="form-label">End Date</label>
            <input
              class="form-control"
              type="date"
              id="endDate"
              [formControl]="
                newDeploymentForm.controls.licenseConfiguration.controls.endDate
              "
            />
          </div>
        </div>

        <div class="select-buttons">
          <div class="d-flex align-items-center g-g">
            <label class="select-buttons-label">Fronthaul Type</label>
            <div class="select-buttons-container">
              @for (
                type of newDeploymentForm.controls.fronthaulTypes.controls;
                track $index
              ) {
                <button
                  type="button"
                  class="select-btn"
                  [class.light]="!type.value.checked"
                  (click)="onSelectFronthaulType(type)"
                >
                  {{ (type.value.type | fronthaulConfig)?.label }}
                </button>
              }
            </div>
          </div>

          <div class="d-flex align-items-center g-g">
            <label class="select-buttons-label">Frequency Range</label>
            <div class="select-buttons-container">
              @for (
                range of newDeploymentForm.controls.frequencyRanges.controls;
                track $index
              ) {
                <button
                  type="button"
                  class="select-btn"
                  [class.light]="!range.value.checked"
                  (click)="onSelectFrequencyRange(range)"
                >
                  {{ range.value.type }}
                </button>
              }
            </div>
          </div>

          <div class="d-flex align-items-center g-g">
            <label class="select-buttons-label">Duplex Mode</label>
            <div class="select-buttons-container">
              @for (
                mode of newDeploymentForm.controls.duplexModes.controls;
                track $index
              ) {
                <button
                  type="button"
                  class="select-btn"
                  [class.light]="!mode.value.checked"
                  (click)="onSelectDuplexMode(mode)"
                >
                  {{ mode.value.type }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <section class="licensing-configuration">
        <header>Licensing</header>
        <div class="licensing-list">
          <div class="licensing-list-group align-self-end">
            <div class="d-flex">
              @let education = newDeploymentForm.value.education;
              <button
                type="button"
                class="select-btn"
                [class.light]="!education"
                (click)="
                  newDeploymentForm.controls.education.patchValue(!education)
                "
              >
                Education
              </button>

              @let kubernetes = newDeploymentForm.value.kubernetes;
              <button
                type="button"
                class="select-btn"
                [class.light]="!kubernetes"
                (click)="
                  newDeploymentForm.controls.kubernetes.patchValue(!kubernetes)
                "
              >
                Kubernetes
              </button>

              @let advancedMode = newDeploymentForm.value.advancedMode;
              <button
                id="advanced-mode"
                type="button"
                class="select-btn"
                [class.light]="!advancedMode"
                (click)="
                  newDeploymentForm.controls.advancedMode.patchValue(
                    !advancedMode
                  )
                "
              >
                Advanced Mode
              </button>
            </div>
          </div>

          <div class="licensing-list-group">
            <header>Features</header>
            <div class="d-flex">
              @let flexRic = newDeploymentForm.value.flexRic;
              <button
                type="button"
                class="select-btn"
                [class.light]="!flexRic"
                (click)="
                  newDeploymentForm.controls.flexRic.patchValue(!flexRic)
                "
              >
                FlexRIC
              </button>

              @let ueManagement = newDeploymentForm.controls.ueManagement;
              @if (ueManagement.controls.enabled.value) {
                <button
                  type="button"
                  class="select-btn"
                  (click)="toggleUeManagement()"
                  [oaiboxBsPopover]="oaiUesPopover"
                  placement="bottom"
                  trigger="manual"
                  container="body"
                >
                  UE Management
                </button>
              } @else {
                <button
                  type="button"
                  class="select-btn light"
                  (click)="toggleUeManagement()"
                >
                  UE Management
                </button>
              }

              @let networkSlicing = newDeploymentForm.value.networkSlicing;
              <button
                type="button"
                class="select-btn"
                [class.light]="!networkSlicing"
                (click)="
                  newDeploymentForm.controls.networkSlicing.patchValue(
                    !networkSlicing
                  )
                "
              >
                Network Slicing
              </button>
            </div>
          </div>

          <div class="licensing-list-group">
            <header>Premium Features</header>
            <div class="d-flex">
              @let mobility = newDeploymentForm.value.mobility;
              <button
                type="button"
                class="select-btn"
                [class.light]="!mobility"
                (click)="
                  newDeploymentForm.controls.mobility.patchValue(!mobility)
                "
              >
                Mobility
              </button>

              @let qosium = newDeploymentForm.value.qosium;
              <button
                type="button"
                class="select-btn"
                [class.light]="!qosium"
                (click)="newDeploymentForm.controls.qosium.patchValue(!qosium)"
              >
                Qosium
              </button>

              @let ris = newDeploymentForm.value.ris;
              <button
                type="button"
                class="select-btn"
                [class.light]="!ris"
                (click)="newDeploymentForm.controls.ris.patchValue(!ris)"
              >
                RIS
              </button>

              @let multiRan = newDeploymentForm.value.multiRan;
              <button
                type="button"
                class="select-btn"
                [class.light]="!multiRan"
                (click)="
                  newDeploymentForm.controls.multiRan.patchValue(!multiRan)
                "
              >
                Multi-RAN
              </button>

              @let redCap =
                newDeploymentForm.controls.redCapConfiguration.value.redCap;
              <button
                type="button"
                class="select-btn"
                [class.light]="!redCap"
                (click)="
                  newDeploymentForm.controls.redCapConfiguration.controls.redCap.patchValue(
                    !redCap
                  )
                "
              >
                RedCap
              </button>

              @let offlineEnabled =
                newDeploymentForm.controls.offlineConfiguration.controls.enabled
                  .value;
              <button
                type="button"
                class="select-btn"
                [class.light]="!offlineEnabled"
                (click)="toggleOffline()"
              >
                Offline
              </button>
            </div>
          </div>

          <div class="licensing-list-group">
            <header>Use Cases Library</header>
            <div class="d-flex flex-wrap">
              @let digitalTwin = newDeploymentForm.value.digitalTwin;
              <button
                type="button"
                class="select-btn"
                [class.light]="!digitalTwin"
                (click)="
                  newDeploymentForm.controls.digitalTwin.patchValue(
                    !digitalTwin
                  )
                "
              >
                Digital Twin
              </button>

              @let isac = newDeploymentForm.value.isac;
              <button
                type="button"
                class="select-btn"
                [class.light]="!isac"
                (click)="newDeploymentForm.controls.isac.patchValue(!isac)"
              >
                ISAC
              </button>

              @let radarDetection = newDeploymentForm.value.radarDetection;
              <button
                type="button"
                class="select-btn"
                [class.light]="!radarDetection"
                (click)="
                  newDeploymentForm.controls.radarDetection.patchValue(
                    !radarDetection
                  )
                "
              >
                Radar Detection
              </button>

              @let visionAidedCommunications =
                newDeploymentForm.value.visionAidedCommunications;
              <button
                type="button"
                class="select-btn"
                [class.light]="!visionAidedCommunications"
                (click)="
                  newDeploymentForm.controls.visionAidedCommunications.patchValue(
                    !visionAidedCommunications
                  )
                "
              >
                Vision Aided Communications
              </button>
            </div>
          </div>
        </div>
      </section>

      @let redCapConfiguration = newDeploymentForm.controls.redCapConfiguration;
      @if (redCapConfiguration.value.redCap) {
        <section class="redcap-configuration">
          <header>RedCap Configuration</header>
          <div
            class="form redcap-configuration-form"
            [formGroup]="redCapConfiguration"
          >
            <div class="form-row flex-wrap">
              <div class="flex-fill">
                <label for="halfDuplex" class="form-label"
                  >Half Duplex RedCap Allowed</label
                >
                <input
                  id="halfDuplex"
                  type="number"
                  class="form-control"
                  [formControl]="
                    redCapConfiguration.controls.halfDuplexRedCapAllowedR17
                  "
                />
              </div>

              <div class="flex-fill">
                <label for="cellBarredRedCap1" class="form-label"
                  >Cell Barred RedCap1 Rx</label
                >
                <input
                  id="cellBarredRedCap1"
                  type="number"
                  class="form-control"
                  [formControl]="
                    redCapConfiguration.controls.cellBarredRedCap1RxR17
                  "
                />
              </div>

              <div class="flex-fill">
                <label for="cellBarredRedCap2" class="form-label"
                  >Cell Barred RedCap2 Rx</label
                >
                <input
                  id="cellBarredRedCap2"
                  type="number"
                  class="form-control"
                  [formControl]="
                    redCapConfiguration.controls.cellBarredRedCap2RxR17
                  "
                />
              </div>
              <div class="flex-fill">
                <label for="intraFreqReselection" class="form-label"
                  >Intra Freq. Reselection RedCap</label
                >
                <input
                  id="intraFreqReselection"
                  type="number"
                  class="form-control"
                  [formControl]="
                    redCapConfiguration.controls.intraFreqReselectionRedCapR17
                  "
                />
              </div>
            </div>

            <section class="timers-configuration">
              <span class="form-label">Timers Configuration</span>
              <div>
                <div class="flex-fill">
                  <label for="t300" class="form-label">T300</label>
                  <input
                    id="t300"
                    type="number"
                    class="form-control"
                    [formControl]="redCapConfiguration.controls.t300"
                  />
                </div>

                <div class="flex-fill">
                  <label for="t301" class="form-label">T301</label>
                  <input
                    id="t301"
                    type="number"
                    class="form-control"
                    [formControl]="redCapConfiguration.controls.t301"
                  />
                </div>

                <div class="flex-fill">
                  <label for="t310" class="form-label">T310</label>
                  <input
                    id="t310"
                    type="number"
                    class="form-control"
                    [formControl]="redCapConfiguration.controls.t310"
                  />
                </div>

                <div class="flex-fill">
                  <label for="t311" class="form-label">T311</label>
                  <input
                    id="t311"
                    type="number"
                    class="form-control"
                    [formControl]="redCapConfiguration.controls.t311"
                  />
                </div>

                <div class="flex-fill">
                  <label for="n310" class="form-label">N310</label>
                  <input
                    id="n310"
                    type="number"
                    class="form-control"
                    [formControl]="redCapConfiguration.controls.n310"
                  />
                </div>

                <div class="flex-fill">
                  <label for="n311" class="form-label">N311</label>
                  <input
                    id="n311"
                    type="number"
                    class="form-control"
                    [formControl]="redCapConfiguration.controls.n311"
                  />
                </div>

                <div class="flex-fill">
                  <label for="t319" class="form-label">T319</label>
                  <input
                    id="t319"
                    type="number"
                    class="form-control"
                    [formControl]="redCapConfiguration.controls.t319"
                  />
                </div>
              </div>
            </section>
          </div>
        </section>
      }

      <footer>
        <button
          type="submit"
          class="btn btn-success"
          [disabled]="newDeploymentForm.invalid || ongoingRequest"
        >
          @if (ongoingRequest) {
            <i class="fa-solid fa-spinner rotating"></i>
          } @else {
            Save
          }
        </button>
      </footer>
    </form>
  </oaibox-stats-card>
</main>

<ng-template #oaiUesPopover>
  @let oaiUeMachineIds =
    newDeploymentForm.controls.ueManagement.controls.oaiUeMachineIds;
  <div class="oai-ues-popover">
    <span class="oai-ues-popover-title">OAI UE Machine IDs</span>
    @for (machineId of oaiUeMachineIds.controls; track $index) {
      <div class="oai-ues-popover-row">
        <div class="errors-wrapper">
          <input
            type="text"
            class="form-control"
            placeholder="Machine ID"
            [formControl]="machineId"
            [class.invalid-input]="machineId.invalid && machineId.dirty"
          />
          @if (machineId.invalid && machineId.dirty) {
            <div class="input-error">Invalid UUID format</div>
          }
        </div>
        <i
          class="fa-solid fa-minus oai-ues-remove"
          (click)="removeOaiUeMachineId($index)"
        ></i>
      </div>
    }
    <i class="fa-solid fa-plus oai-ues-add" (click)="addOaiUeMachineId()"></i>
  </div>
</ng-template>
